import { cloneDeep } from "lodash";

export const setActiveContentAllowMultipleSelection = ({
  contents,
  activeContentId,
  allowMultipleSelection,
}) => {
  return contents.map((content) => {
    if (content.id === activeContentId) {
      content.allowMultipleSelection = allowMultipleSelection;
    }

    return cloneDeep(content);
  });
};

export default setActiveContentAllowMultipleSelection;
